import { dscvrIcApi } from '@/shared/api';

export const useRejectFrameTransactionMutation = (
  frameUrl: string,
  transactionId?: string,
) => {
  return dscvrIcApi.frame.rejectFrameTransaction(frameUrl, transactionId);
};
